import React from 'react';
import {Alert, Button} from 'react-bootstrap';
import {useTheme} from '../../../../shared/context/ThemeContext';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Editor from '@monaco-editor/react';
import EditRounded from '@mui/icons-material/EditRounded';
import SaveRounded from '@mui/icons-material/SaveRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import ArticleRounded from '@mui/icons-material/ArticleRounded';
import {useConfigText} from '../../hooks/useConfigText';
import '../../styles/documentation.css';

const ConfigText = ({eid}) => {
  const {resolvedTheme} = useTheme();
  const {loading, error, content, setContent, isEditing, setIsEditing, lastUpdated, save, cancel} = useConfigText(eid);

  return (
    <div className="documentation-container fade-in position-relative">
      {error && <Alert variant="warning" className="mb-3">{error}</Alert>}

      <div className="documentation-actions" style={{zIndex: 100, pointerEvents: 'none'}}>
        <div className="documentation-actions-inner" style={{pointerEvents: 'auto'}}>
          {isEditing ? (
            <>
              <Button variant="secondary" size="sm" onClick={cancel} disabled={loading}
                      className="shadow-sm d-flex align-items-center gap-1" style={{opacity: 0.9}}>
                <CloseRounded fontSize="small"/> Cancel
              </Button>
              <Button variant="primary" size="sm" onClick={save} disabled={loading}
                      className="shadow-sm d-flex align-items-center gap-1">
                <SaveRounded fontSize="small"/> Save
              </Button>
            </>
          ) : (
            <Button variant="light" size="sm" onClick={() => setIsEditing(true)}
                    className="shadow-sm border d-flex align-items-center gap-1" style={{opacity: 0.8}}>
              <EditRounded fontSize="small"/> Edit
            </Button>
          )}
        </div>
      </div>

      {isEditing ? (
        <div className="documentation-editor-container h-100">
          <Editor
            height="100%"
            defaultLanguage="markdown"
            value={content}
            onChange={(value) => setContent(value || '')}
            theme={resolvedTheme === 'dark' ? 'vs-dark' : 'vs'}
            options={{
              automaticLayout: true,
              minimap: {enabled: false},
              fontSize: 14,
              wordWrap: 'on',
              padding: {top: 60, bottom: 20},
              scrollBeyondLastLine: false,
            }}
          />
        </div>
      ) : (
        <div className="documentation-content custom-scrollbar h-100">
          <div style={{paddingTop: '1rem'}}>
            {(!content && !loading) ? (
              <div className="documentation-empty-state">
                <ArticleRounded style={{fontSize: 48, opacity: 0.3, marginBottom: '1rem'}}/>
                <p>No documentation written yet.</p>
                <Button variant="link" onClick={() => setIsEditing(true)}>Start writing</Button>
              </div>
            ) : (
              <div className="markdown-body">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
              </div>
            )}
            {!isEditing && lastUpdated && (
              <div className="text-end mt-4 text-muted small pt-2">
                Last updated: {lastUpdated.toLocaleString()}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigText;
